import { WbUserPreferenceRow } from '@mst-fe/shared';

import { ErrorNotification } from '../../../services/error-notification';
import { UsersApi } from '../../users/users-api';
import { UserInfoModel } from './user-info';

export interface UserPreferencesModalModel {
  loading: boolean;
  touched: boolean;
  preferences?: Omit<WbUserPreferenceRow, 'userSubject'> | undefined;
}

export function initialUserPreferencesModalModel(): UserPreferencesModalModel {
  return { loading: true, touched: false, preferences: undefined };
}

export function asUserPreferencesUpdate(model: () => UserInfoModel, update: (_: UserInfoModel) => void) {
  return (userPreferences: UserPreferencesModalModel | undefined) => update({ ...model(), userPreferencesModal: userPreferences });
}

export async function loadUserPreferences(
  api: UsersApi,
  update: (_: UserPreferencesModalModel) => void
): Promise<ErrorNotification | undefined> {
  update(initialUserPreferencesModalModel());
  const ERROR_MESSAGE = 'Error retrieving the user preferences';
  try {
    const res = await api.getUserPreferences();
    if (!res?.ok) {
      return { message: ERROR_MESSAGE };
    }
    update({
      loading: false,
      touched: false,
      preferences: res.body,
    });
  } catch (error) {
    return { message: ERROR_MESSAGE };
  }
}

export async function saveUserPreferences(
  api: UsersApi,
  preferences: Omit<WbUserPreferenceRow, 'userSubject'>
): Promise<ErrorNotification | undefined> {
  const ERROR_MESSAGE = 'Error saving the user preferences';
  try {
    const res = await api.saveUserPreferences(preferences);
    if (!res?.ok) {
      return { message: ERROR_MESSAGE };
    }
  } catch (error) {
    return { message: ERROR_MESSAGE };
  }
}
